import { Api, API_KEYS } from './base.api';

interface HomeLocation {
  chargers?: unknown[];
}

export const locationsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchChargerIdbyChargerName: builder.query<string, string>({
      query: (chargerName: string) => ({
        url: `${API_KEYS.LOCATIONS}?searchText=${chargerName}`,
        method: 'GET',
      }),
      transformResponse: (response: any, meta, arg) => {
        let deviceId;
        response.forEach((location: any) => {
          location.chargers.forEach((charger) => {
            if (charger.chargerName.toUpperCase() === arg.toUpperCase()) {
              deviceId = charger.deviceId;
            }
          });
        });
        return deviceId;
      },
    }),
    hasHomeChargers: builder.query<boolean, void>({
      query: () => ({
        url: API_KEYS.LOCATIONS,
        method: 'GET',
        params: { scope: 'home' },
      }),
      transformResponse: (response: HomeLocation[]) => {
        if (!Array.isArray(response)) {
          throw new Error('Unexpected home locations response');
        }
        return response.some((location) => (location.chargers?.length ?? 0) > 0);
      },
    }),
  }),
});

export const { useFetchChargerIdbyChargerNameQuery, useLazyHasHomeChargersQuery } = locationsApi;
